enum IconsEnum {
  PEOPLE = 'IconPeople',
  PIG = 'IconPig',
  RENTAL_OBJECT = 'IconRentalObject',
  CREDIT_CARD = 'IconCreditCard',
  KEY_CHAIN = 'IconKeychain',
  TIMER = 'IconTimer',
  EYE_WEAR = 'IconEyeWear',
  EMAIL = 'IconEmail',
  ERROR = 'IconError',
  EYEWEAR = 'IconEyeWear',
  HAPPY_FACE = 'IconHappyFace',
  PEN_PLUS = 'IconPenPlus',
  SIGNING = 'IconSigning',
  UTILITIES = 'IconUtilities',
  RECIPE = 'IconRecipe',
  SCALE = 'IconScale',
  TRASH = 'IconTrash',
  HELP = 'IconHelp',
  ANGLE_RIGHT = 'IconAngleRight',
  ANGLE_LEFT = 'IconAngleLeft',
  WORLD_NETWORK = 'IconWorldNetwork',
  WARNING = 'IconExclamation',
  GRAPH_DOWNWARD = 'IconGraphDownward',
  EURO_SYMBOL = 'IconEuroSymbol',
  THUMB_DOWN = 'IconThumbDown',
  LORRY = 'IconLorry',
  LAMP = 'IconLamp',
  MAPPIN = 'IconMapPin',
  CHECK_CIRCLE = 'IconCheckCircle',
  CROSS_CIRCLE = 'IconCrossCircle',
  PROFILE_CIRCLE = 'IconProfileCircle',
}

enum IconsColorEnum {
  DEFAULT = 'text-secondary',
  BLACK = 'text-black',
  ORANGE = 'text-orange',
}
export { IconsEnum, IconsColorEnum };
